'use client';

import { useState } from 'react';

import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '@/slw/shared/ui/accordion';
import { Card, CardContent } from '@/slw/shared/ui/card';

export function GeneralQuestion() {
  const [open, setOpen] = useState(true);

  const triggerClass = 'md:pt-6 md:pb-4 py-4 text-sm md:text-base font-semibold leading-[100%] flex items-center';

  return (
    <Card className='rounded-2xl bg-[#F7F7F7] shadow-sm mb-6 border-0 p-6 md:p-8'>
      <div className='flex items-center justify-between'>
        <h3 className='text-xl md:text-[2rem] leading-[100%] font-bold text-foreground'>General Question</h3>
        <button
          type='button'
          className='text-sm font-normal leading-[150%] text-muted-foreground hover:text-primary transition'
          onClick={() => setOpen((v) => !v)}
        >
          {open ? 'Hide' : 'Show'}
        </button>
      </div>
      {open && (
        <CardContent className='pt-0 px-0 pb-0'>
          <Accordion type='multiple' className='divide-y divide-[#E5E5E5]'>
            <AccordionItem value='what-is-cc'>
              <AccordionTrigger className={triggerClass}>What is Clovis Classics?</AccordionTrigger>
              <AccordionContent className='pl-0 md:text-sm text-xs font-normal leading-[150%]'>
                Clovis Classics is a premium online marketplace dedicated to buying, selling, and celebrating classic
                and collector vehicles. We help hot rod and classic car enthusiasts connect with buyers and seller of
                the vehicles—and stories—they love.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value='what-types'>
              <AccordionTrigger className={triggerClass}>What types of vehicles can be listed?</AccordionTrigger>
              <AccordionContent className='pl-0 md:text-sm text-xs font-normal leading-[150%]'>
                <div>
                  We welcome a wide range of collector vehicles but stay true to our roots.
                  <br />
                  Listings can be:
                  <br />
                  Pre-War (earlier than 1942)
                  <br />
                  Post War (1946–1974)
                  <br />
                  Muscle Cars (1964–1974)
                </div>
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value='sell-cars-directly'>
              <AccordionTrigger className={triggerClass}>Do you sell cars directly?</AccordionTrigger>
              <AccordionContent className='pl-0 md:text-sm text-xs font-normal leading-[150%]'>
                No. Clovis Classics is a digital classifieds marketplace. We connect individual sellers, collectors, and
                dealers with qualified buyers looking for classic rides.
              </AccordionContent>
            </AccordionItem>
            <AccordionItem value='contact-support'>
              <AccordionTrigger className={triggerClass}>How do I contact customer support?</AccordionTrigger>
              <AccordionContent className='pl-0 md:text-sm text-xs font-normal leading-[150%]'>
                You can reach us anytime at support@ClovisClassics.com. We respond within 24 hours on weekdays.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </CardContent>
      )}
    </Card>
  );
}
